import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemAiIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22.8 8.31001L17.84 6.16001L15.68 1.20001C15.44 0.650006 14.54 0.650006 14.3 1.20001L12.14 6.16001L7.17999 8.31001C6.58999 8.54001 6.58999 9.45001 7.17999 9.69001L12.14 11.84L14.3 16.8C14.53 17.39 15.44 17.39 15.68 16.8L17.84 11.84L22.8 9.69001C23.39 9.46001 23.39 8.55001 22.8 8.31001ZM16.97 10.58C16.8 10.66 16.66 10.79 16.58 10.97L14.99 14.62L13.41 10.97C13.33 10.8 13.2 10.66 13.02 10.58L9.36999 9.00001L13.02 7.42001C13.19 7.34001 13.33 7.21001 13.41 7.03001L14.99 3.38001L16.58 7.03001C16.66 7.20001 16.79 7.34001 16.97 7.42001L20.61 9.00001L16.97 10.58Z"
        fill={color}
      />
      <path
        d="M11.8 16.81L8.59001 15.41L7.19001 12.2C6.95001 11.65 6.05001 11.65 5.81001 12.2L4.41001 15.41L1.20001 16.81C0.610007 17.04 0.610007 17.95 1.20001 18.19L4.41001 19.59L5.81001 22.8C6.04001 23.39 6.95001 23.39 7.19001 22.8L8.59001 19.59L11.8 18.19C12.39 17.96 12.39 17.05 11.8 16.81ZM7.72001 18.33C7.55001 18.41 7.41001 18.54 7.33001 18.72L6.50001 20.62L5.67001 18.72C5.59001 18.55 5.46001 18.41 5.28001 18.33L3.38001 17.5L5.28001 16.67C5.45001 16.59 5.59001 16.46 5.67001 16.28L6.50001 14.38L7.33001 16.28C7.41001 16.45 7.54001 16.59 7.72001 16.67L9.62001 17.5L7.72001 18.33Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemAiIcon.displayName = 'ItemAiIcon';
